import css from 'styled-jsx/css';

const badgesStyles = (lineHeight) => {
  const lineHeightValue = lineHeight || '1.44rem';

  return css`
    /* stylelint-disable declaration-no-important */
    .discount-badge {
      display: flex;
      align-self: center;
      &-item {
        padding: 2px 5px;
        border-radius: 3px;
        margin-right: 0 !important;
        line-height: ${lineHeightValue} !important;
      }
    }
  `;
};

export default badgesStyles;
